import { Injectable } from '@angular/core';
import { padStart } from 'lodash';
import moment from 'moment';
import * as momentTimezone from 'moment-timezone';

const defaultFormat = 'MM/DD/YYYY hh:mm A';
const defaultTimeZone = 'America/New_York';

@Injectable({ providedIn: 'root' })
export class DateTimeService {
  static getCurrentDate(): Date {
    return new Date();
  }

  static createDate(year, month, date) {
    // NOTE: creating an ISO string for date creation is preferred, since it will avoid
    // the annoying "month offset index" issue in JS; this helps ensure the proper date
    // is created for whatever values the consumer provides
    // [Patterson, John - 2017.06.30.11.03]
    const isoDateString = year + '-' + padStart(month, 2, '0') + '-' + padStart(date, 2, '0');
    console.log('date string: ' + isoDateString);
    const output = moment(isoDateString).toDate();
    return output;
  }

  static addMonths(date, number) {
    const output = moment(date).add(number, 'months').toDate();
    return output;
  }

  static addDays(date, number) {
    const output = moment(date).add(number, 'days').toDate();
    return output;
  }

  static getCurrentDateFormatted(format): string {
    const date = DateTimeService.getCurrentDate();
    const formattedDate = moment(date).format(format);
    return formattedDate;
  }

  static format(value, format?) {
    const momentFormat = format || defaultFormat;
    const result = moment(value).format(momentFormat);
    return result;
  }

  static formatET(value, format?) {
    const momentFormat = format || defaultFormat;

    return moment(value).tz(defaultTimeZone).format(momentFormat) + ' ET';
  }

  static createIMyDateFromDate(date) {
    const output = {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
    return output;
  }
}
